import { render, staticRenderFns } from "./Pareto.vue?vue&type=template&id=77189a78&"
import script from "./Pareto.vue?vue&type=script&lang=js&"
export * from "./Pareto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports